// extracted by mini-css-extract-plugin
module.exports = {"courses":"plumbing_courses__E7ukA","img1":"plumbing_img1__3iNEk","img2":"plumbing_img2__2FAqp","img3":"plumbing_img3__3LsUO"};